module.exports = __webpack_public_path__ + "static/media/nft4.4b335795.jpg";